<template>
  <div id="box" class="column">
    <div id="content" class="column" v-if="tableData.status == 'right'">
      <div id="content-title" class="column">
        <span>姓名：{{ tableData.XM }}</span>
        <span>{{ tableData.SMSJ }}</span>
      </div>
      <div id="content-list-title">基本信息</div>
      <div id="content-list" class="column">
        <div class="content-list-content">
          <div class="content-list-content-left">学号</div>
          <div class="content-list-content-right">{{ tableData.XH }}</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">院系</div>
          <div class="content-list-content-right active">
            {{ tableData.YX }}
          </div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">班级</div>
          <div class="content-list-content-right">{{ tableData.Bj }}</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">类型</div>
          <div class="content-list-content-right">{{ tableData.SMLX }}</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">返校日期</div>
          <div class="content-list-content-right">{{ tableData.FXRQ }}</div>
        </div>
      </div>
    </div>
    <div id="content2" v-else-if="tableData.status == 'noUser||userAbnormal'">
      暂无人员信息
    </div>
    <div id="content2" v-else-if="tableData.status == 'noLeave'">
      你不在请假时间之内
    </div>
    <div id="content3" v-else-if="tableData.status == 'dormError'">
      你不住在该宿舍
    </div>
  </div>
</template>
<script>
import { accountScan } from "@/api/zhicheng.js";
export default {
  name: "App",
  data() {
    return {
      type: "",
      location: "",
      tableData: {
        status: "right",
      },
    };
  },
  created() {
    // this.handleUrlInfo()
    console.log("路由参数",this.$route.query, this.$route.params);
    this.handPersonalDetailList();
    this.GetScan()
  },
  methods: {
    // 获取链接后拼接参数
    handleUrlInfo() {
      let urlInfo = window.location.href + "";
      let urlParams = urlInfo.split("?");
      let urlParamsList = urlParams[1].split("&");
      this.type = urlParamsList[0].split("=")[1];
      this.location = urlParamsList[1].split("=")[1];
    },
    handPersonalDetailList() {
      let data = {
        type: this.type,
        location: this.location,
      };
      accountScan(data).then((res) => {
        this.tableData = res.data;
      });
    },
    async GetScan() {
      let data = await accountScan();
      console.log(data)
    },
  },
};
</script>

<style lang='scss' scoped>
* {
  margin: 0;
  padding: 0;
}
.column {
  display: flex;
  flex-direction: column;
  /* flex-wrap:wrap; */
}
#box {
  width: 100vw;
  height: 100vh;
  background: #edf4fa;
}
#content {
  width: 90%;
  height: 80%;
  background: #fff;
  border-radius: 6px;
  margin-top: 5%;
  margin-left: 5%;
}
#content-title {
  padding-top: 5%;
}
#content-title > span {
  font-size: 16px;
  padding-left: 25%;
  line-height: 1.8;
}
#content-title > span:first-child {
  font-weight: 300;
}
#content-title > span:last-child {
  font-weight: 700;
  color: red;
}
#content-list {
  padding-top: 5%;
  padding-left: 5%;
}
#content-list-title {
  font-size: 18px;
  font-weight: 300;
  width: 100%;
  padding-left: 5%;
}
.content-list-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 3% 0;
}
.content-list-content-left {
  width: 28%;
  border-right: 1px solid #ccc;
  color: #a6bedb;
}
.content-list-content-right {
  width: 60%;
  font-weight: 400;
  font-size: 16px;
  padding-left: 7%;
}
</style>